const trimTrailingSlash = (value: string): string => value.replace(/\/+$/, '')

const resolveRuntimeUrl = (configuredUrl: string | undefined, fallbackPath: string): string => {
  const fallbackUrl = new URL(fallbackPath, window.location.origin)

  if (!configuredUrl) {
    return fallbackUrl.toString()
  }

  try {
    const parsedConfiguredUrl = new URL(configuredUrl)

    if (parsedConfiguredUrl.origin === window.location.origin) {
      return parsedConfiguredUrl.toString()
    }

    return new URL(
      `${parsedConfiguredUrl.pathname}${parsedConfiguredUrl.search}${parsedConfiguredUrl.hash}`,
      window.location.origin,
    ).toString()
  } catch (_error) {
    return fallbackUrl.toString()
  }
}

const getRequiredEnv = (value: string | undefined, envName: string): string => {
  if (!value) {
    throw new Error(`Missing required auth environment variable: ${envName}`)
  }

  return value
}

export interface AuthConfig {
  authProviderBaseUrl: string
  clientId: string
  redirectUri: string
  scope: string
}

export const getAuthConfig = (): AuthConfig => ({
  authProviderBaseUrl: trimTrailingSlash(
    getRequiredEnv(import.meta.env.VITE_AUTH_PROVIDER_URL, 'VITE_AUTH_PROVIDER_URL'),
  ),
  clientId: getRequiredEnv(import.meta.env.VITE_APP_AUTH_CLIENT_ID, 'VITE_APP_AUTH_CLIENT_ID'),
  redirectUri: resolveRuntimeUrl(
    import.meta.env.VITE_APP_CALLBACK_URI,
    '/authentication/code/callback/',
  ),
  scope: getRequiredEnv(import.meta.env.VITE_APP_AUTH_SCOPE, 'VITE_APP_AUTH_SCOPE'),
})

export {resolveRuntimeUrl, trimTrailingSlash}
